import React from "react";
import AdminPanel from "../shared/AdminPanel";
import panelStyles from "../styles/Panel.module.css";
import styles from "../styles/UsersSection.module.css";
import { formatDateTime } from "../utils/formatters";

function UsersSectionBody({ state, actions }) {
  const { searchId, user, actionData } = state;

  return (
    <>
      <div className={styles.searchRow}>
        <input
          type="text"
          value={searchId}
          placeholder="ID пользователя"
          className={panelStyles.input}
          onChange={(event) => actions.setSearchId(event.target.value)}
        />
        <button type="button" className={panelStyles.button} onClick={actions.search}>
          Найти
        </button>
      </div>

      {user ? (
        <div className={styles.userCard}>
          <pre>{`ID: ${user.id}
UID: ${user.uid}
Имя: ${user.first_name}
Реферер: ${user.ref_activation || "-"}
Рефералов: ${user.ref_count || 0}
Баланс: ${user.balance || 0}
Тариф: ${user.premium_id || 0}
Премиум до: ${formatDateTime(user.premium_time ? new Date(user.premium_time * 1000) : null)}
Платежный флаг: ${user.settings_payment_id || "-"}
Следующий платеж: ${formatDateTime(user.settings_payment_time ? new Date(user.settings_payment_time * 1000) : null)}`}</pre>

          <div className={styles.actionGrid}>
            <div className={styles.actionBlock}>
              <input
                type="number"
                placeholder="Изменение баланса"
                value={actionData.balance}
                className={panelStyles.input}
                onChange={(event) =>
                  actions.setActionData({ ...actionData, balance: event.target.value })
                }
              />
              <button type="button" className={panelStyles.button} onClick={() => actions.runAction("balance")}>
                Изменить баланс
              </button>
            </div>

            <div className={styles.actionBlock}>
              <select
                value={actionData.premiumId}
                className={panelStyles.select}
                onChange={(event) =>
                  actions.setActionData({ ...actionData, premiumId: event.target.value })
                }
              >
                <option value={1}>Lite</option>
                <option value={2}>Pro</option>
                <option value={3}>Max</option>
                <option value={0}>Убрать подписку</option>
              </select>
              <input
                type="number"
                placeholder="Дней"
                value={actionData.premiumDays}
                className={panelStyles.input}
                onChange={(event) =>
                  actions.setActionData({ ...actionData, premiumDays: event.target.value })
                }
              />
              <button type="button" className={panelStyles.button} onClick={() => actions.runAction("premium")}>
                Изменить подписку
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className={panelStyles.note}>Введите ID пользователя, чтобы загрузить карточку аккаунта.</div>
      )}
    </>
  );
}

export function UsersSection({ mode = "panel", isOpen = true, onToggle, state, actions }) {
  if (mode === "page") {
    return <UsersSectionBody state={state} actions={actions} />;
  }

  return (
    <AdminPanel id="users" title="Пользователи" isOpen={isOpen} onToggle={onToggle}>
      <UsersSectionBody state={state} actions={actions} />
    </AdminPanel>
  );
}

export default UsersSection;
